export const READ_ALL_NOTIFICATION_ENDPOINT = '/clientteling/Read-All-Notifications';
